module.exports = __webpack_public_path__ + "img/title-boshu.3a358368.svg";